import pkg from '../../../package.json';

export class CacheBusterService {
    constructor($window, $log) {
        this.$window = $window;
        this.$log = $log;

        this.currentVersion = pkg.version;
        this.storedVersion = localStorage.getItem('app_version');

        this.checkVersion();
    }

    checkVersion() {
        if (!this.storedVersion) {
            localStorage.setItem('app_version', this.currentVersion);
            return;
        }

        if (this.storedVersion !== this.currentVersion) {
            this.$log.info(`Version changed from ${this.storedVersion} to ${this.currentVersion}. Refreshing.`);
            this.clearCachesAndReload();
        }
    }

    clearCachesAndReload() {
        localStorage.setItem('app_version', this.currentVersion);

        // Clear service worker caches if available
        if ('caches' in this.$window) {
            caches.keys().then(names => {
                names.forEach(name => caches.delete(name));
            });
        }

        // Unregister service workers
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.getRegistrations().then(registrations => {
                registrations.forEach(reg => reg.unregister());
            });
        }

        // Force hard reload
        this.$window.location.reload(true);
    }
}
